import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16548c6d")

_pushScopeId("data-v-16548c6d")
const _hoisted_1 = { class: "reportConfirm_reportItem" }
const _hoisted_2 = { class: "reportConfirm_reportItem_cont" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "工况", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "手续", -1)
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "其他", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_reportComfirmTitle = _resolveComponent("reportComfirmTitle")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_reportComfirmTitle, {
      titleTxt: "车况备注",
      isShowRight: false
    }),
    _createVNode("div", _hoisted_2, [
      (_ctx.renderData.workConditionRemark)
        ? (_openBlock(), _createBlock("p", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(_toDisplayString(_ctx.renderData.workConditionRemark), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.renderData.procedureRemark)
        ? (_openBlock(), _createBlock("p", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(_toDisplayString(_ctx.renderData.procedureRemark), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.renderData.carSummaryInfo)
        ? (_openBlock(), _createBlock("p", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.renderData.carSummaryInfo), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})